<template>
    <div class="p-5 darker">

        <h5>
            Get instant reservations from your own website.
        </h5>

        <div class="my-4">
            Reservations received trough this widget are automatically synced with Pluralo calendar.<br>
            Availabilities, prices, cancellation policy and other important information you enter in your company configurations will be shown to customers during reservation process.
        </div>

        <div class="d-flex align-items-end mb-4" v-if="!showNewWidgetCreator">
            <button class="btn wide" @click="toggleWidgetCreator">New Widget</button>
        </div>

        <!-- widget creator -->
        <div v-if="showNewWidgetCreator" class="mb-5">
            <h2 class="mb-2">Create New</h2>
            <div>
                <widget-editor :isCreatingWidget="true" v-bind:widget.sync="newWidget" :productOptions="productsArray" :validation="$v.newWidget" @refreshWidgetList="downloadAllWidgets" @creatingCancel="creatingCancel" @creatingSave="createWidgetButtonOptions"></widget-editor>
            </div>
        </div>

        <div class="col-sm-12 text-center" v-if="loadingWidgets">
            <loader></loader>
        </div>

        <div class="" v-if="!loadingWidgets">
            <div class="row">
                <div class="col-sm-12">
                    <h2 v-if="widgetsArray.length >0" class="mb-2">Current Widgets</h2>
                    <widget-editor v-bind:widget.sync="widget" :productOptions="productsArray" v-for="widget in sortedWidgets" :key="widget.id" @refreshWidgetList="downloadAllWidgets"></widget-editor>

                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import extendedVSelect from '@/extends/vue-select'
    import {mapGetters, mapActions} from 'vuex'
    import Loader from '@/tools/loaders/loader1'
    import WidgetEditor from '@/tools/widget/widgetEditor'
    import WidgetComposer from '@/tools/widget/widgetComposer'
    import { required, email, minLength } from 'vuelidate/lib/validators'

    export default {
        data: function() {
            return {
                showNewWidgetCreator: false,
                loadingWidgets: false,
                productsArray: null,
                treatedProducts: null,
                futureWidgetName: null,
                widgetsArray: [],
                selectedProduct: {
                    name:'All Products',
                    allProducts: true
                },
                allProducts: {
                    name:'All Products',
                    allProducts: true
                },
                newWidget: null
            }
        },
        validations: {
            newWidget: {
                products: {
                    function () {
                        return true
                        // return this.newWidget.products.length > 0 || this.newWidget.allProducts == true
                    }
                },
                name: {
                    required
                }
            }
        },
        computed: {
            ...mapGetters([
                'account',
                'getWidgets',
                'getCleanDefaultWidget'
            ]),
            sortedWidgets: function () {
                return this.widgetsArray.sort((a, b) => b.id - a.id);
            },
        },
        created: function() {
            this.downloadAllWidgets()
            this.getProducts()
            this.setVirginWidget()
        },
        methods:{
            ...mapActions([
                'getAllWidgets',
                'createWidget',
                'createWidgetOptions',
                'deleteWidget',
                'updateWidget',
                'downloadVirginWidget'
            ]),
            setVirginWidget: function () {
                this.newWidget = JSON.parse(JSON.stringify(this.getCleanDefaultWidget))
            },
            creatingCancel: function () {
                this.showNewWidgetCreator = false
            },
            toggleWidgetCreator: function () {
                this.downloadVirginWidget().then(virginWidget => {
                    let baseWidget = JSON.parse(JSON.stringify(this.getCleanDefaultWidget))
                    this.newWidget = baseWidget
                    this.$set(this.newWidget, 'categoryProductList', virginWidget.categoryProductList)
                    this.showNewWidgetCreator = !this.showNewWidgetCreator
                })
                // this.setVirginWidget()
            },
            getProducts: function() {
                axios.get('/api/booking/Resume', {
                    params: {
                        supplierId: this.account.supplierId
                    }
                }).then(response => {

                    if (response && response.status === 200 && response.data) {

                        this.productsArray = response.data.productList

                        //options for the dropdown
                        this.treatedProducts = JSON.parse(JSON.stringify(response.data.productList))
                        this.treatedProducts.unshift(this.allProducts)

                        return response.data;
                    }
                }).catch (error => {
                    this.$toasted.error(error.response.data.message);
                })
            },
            generateIframeCode: function(guid) {
                return '<iframe src="'+process.env.WIDGET_URL+'/?guid='+guid+'" width="400" height="600" style="position: relative;display: block;margin: auto;border: none;width: 100%;max-width: 400px;height: 600px;max-height:100%;"></iframe>'
            },
            generateWidgetName: function(widget){
                if(widget.products.length == 0){
                    return 'All products'
                } else {
                    return widget.products[0].name
                }
            },
            downloadAllWidgets: function() {
                this.loadingWidgets = true
                this.getAllWidgets().then(response => {
                    this.loadingWidgets = false
                    if(response && response.status == 200){
                        this.widgetsArray = response.data
                    }
                })
            },
            createWidgetButton: function() {
                let productsForWidget = [this.selectedProduct]

                //if "All products is selected"
                if(productsForWidget[0].allProducts){
                    productsForWidget = []
                }

                this.createWidget({
                    name: this.futureWidgetName,
                    products: productsForWidget
                }).then(response => {
                    if(response && response.status == 200){
                        this.futureWidgetName = null
                        this.$toasted.success('Widget generated')
                        this.downloadAllWidgets()
                    }
                })
            },
            createWidgetButtonOptions: function () {
                this.showNewWidgetCreator = false
                this.createWidgetOptions(this.newWidget).then(response => {
                    if(response && response.status == 200){
                        this.futureWidgetName = null
                        this.$toasted.success('Widget generated')
                        this.downloadAllWidgets()
                    }
                })
            },
            widgetCreatorChanged: function () {
                console.log('widgetCreatorChanged');
                this.$v.newWidget.$touch
            },
            deletThisWidget: function(widget) {
                let vm = this
                this.$dialog.confirm('<b>Delete Widget?</b><br>This action is irreversible!')
                .then(function () {
                    // yes
                    vm.deleteWidget(widget).then(response => {
                        vm.$toasted.success(response.data);
                        // vm.downloadAllWidgets()
                        vm.removeWidgetfromArray(widget)
                    })
                })
                .catch(function () {
                    // no
                });

            },
            copyWidget: function(widget) {
                let widgetIframe = this.generateIframeCode(widget.guid)
                this.$clipboard(widgetIframe)
                this.$toasted.success('Widget code copied');
            },
            activateEditionMode: function(widget) {
                widget.originalProducts = widget.products

                if(widget.products.length == 0 || widget.products[0].allProducts){
                    widget.helperSelectedProduct = this.allProducts
                } else {
                    widget.helperSelectedProduct = widget.products[0]
                }


                if(!widget.editing){
                    this.$set(widget, 'editing', true)
                }
            },
            editWidgetProductChanged: function(widget) {
                console.log(widget);
                let productsForWidget = [widget.helperSelectedProduct]

                //if "All products is selected"
                if(productsForWidget[0].allProducts){
                    productsForWidget = []
                }

                widget.products = productsForWidget

            },
            saveEditedWidget: function(widget) {
                if(!widget.loading){
                    this.$set(widget, 'loading', true)
                    this.updateWidget(widget).then(response => {
                        // this.downloadAllWidgets()
                        widget.loading = false
                        widget.editing = false
                    })
                }
            },
            cancelEditedWidget: function(widget) {
                widget.products = widget.originalProducts
                widget.editing = false
            },
            removeWidgetfromArray: function(widgetToRemove) {
                this.widgetsArray.splice(this.widgetsArray.indexOf(widgetToRemove), 1)
            },
        },
        components:{
            vSelect: extendedVSelect,
            Loader,
            WidgetEditor,
            WidgetComposer
        }
    }
</script>

<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// TabWidget.vue?3591b386